import React from "react";
import {SelectProps} from "@mui/material/Select/Select";
import {FormikProps} from "formik";
import {GridTypeMap} from "@mui/material/Grid/Grid";
import {TFunction} from "i18next";
import {Grid} from "@mui/material";
import FormSelectField from "./FormSelectField";
import {get} from "lodash";
import MenuItem from "@mui/material/MenuItem";
import {Stage} from "../../app/api/model/stage";
import {ListRequestParams, useStageListQuery} from "../../app/api/api";
import {skipToken} from "@reduxjs/toolkit/dist/query";

export const NO_SELECTION = "no_selection";

export type StageSelectProps = Omit<SelectProps, "label"> & {
    fieldName: string;
    label: string;
    form: FormikProps<any>;
    isGridItem?: boolean;
    gridProps?: GridTypeMap["props"];
    t: TFunction;
    stages?: Stage[];
    requestParams?: ListRequestParams;
};

const StageSelect = ({
    fieldName,
    label,
    form,
    t,
    isGridItem = false,
    gridProps = {xs: 6},
    stages,
    requestParams = {},
    ...rest
}: StageSelectProps) => {
    const {data: stageListResponse} = useStageListQuery(stages && stages.length ? skipToken : {params: requestParams});
    const getSelect = () => (
        <>
            <FormSelectField
                fieldName={fieldName}
                form={form}
                label={label}
                labelId={`label-${fieldName}`}
                {...rest}
                value={get(form?.values, fieldName)}
            >
                <MenuItem key={"no_selection"} value={NO_SELECTION}>{`${t("label_noSelection")}`}</MenuItem>
                {(stages ? stages : stageListResponse?.payload || []).map((s) => {
                    return (
                        <MenuItem value={s.identifier} key={s.identifier}>
                            {s.description}
                        </MenuItem>
                    );
                })}
            </FormSelectField>
        </>
    );
    return isGridItem ? (
        <Grid item {...gridProps}>
            {getSelect()}
        </Grid>
    ) : (
        getSelect()
    );
};
export default StageSelect;
